import IdentityService, { IdentityAPI } from '../../../services/identityService';

export const manageAppConsent = async (uuid, endpoints, post_data) => {
     return IdentityService.request({
          url: IdentityAPI.parseRequestURL(IdentityAPI.get_my_details+'/applications', {uuid: uuid}),
          method: 'POST',
          baseURL: endpoints.identityAPI,
          data: post_data
        })
}
